import { getSearchParams } from './getSearchParams';

const BOOLEANS = ['true', 'false'];

export type FeatureFlags = Record<string, string | number | boolean>;
// we need to convert the type of the feature flag from URL search params to the correct one
// for the usage in the app (e.g. app is expecting boolean true instead of string 'true', number 1 instead of the string '1' etc.)
export function getValueOfSearchParamsFeatureFlag(featureFlagValueFromSearch: string): string | number | boolean {
	if (BOOLEANS.includes(featureFlagValueFromSearch)) return featureFlagValueFromSearch === 'true';

	if (!Number.isNaN(Number(featureFlagValueFromSearch))) return Number(featureFlagValueFromSearch);

	return featureFlagValueFromSearch;
}

/**
 * Get feature flags overrides from search params
 *
 * @param { FeatureFlags } featureFlags - feature flags from LaunchDarkly (e.g. { useSomeFlag: true, useSomeOtherFlag: false, developPhase: 1 })
 * @return { Record<string, string | number | boolean> }
 */
export function getFeatureFlagsOverride(featureFlags: FeatureFlags) {
	return Object.keys(featureFlags).reduce((reducedFeatureFlagsOverride, featureFlagKey) => {
		const featureFlagValueFromSearchParams = getSearchParams().get(featureFlagKey);

		if (featureFlagValueFromSearchParams) {
			reducedFeatureFlagsOverride[featureFlagKey] = getValueOfSearchParamsFeatureFlag(
				featureFlagValueFromSearchParams
			);
		}

		return reducedFeatureFlagsOverride;
	}, {} as Record<string, string | number | boolean>);
}
